var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4942 17.9258H33.1125C32.5945 17.9258 32.102 18.1746 31.7973 18.6012L23.8144 29.6715L20.1988 24.6543C19.8941 24.2328 19.4066 23.9789 18.8836 23.9789H16.5019C16.1718 23.9789 15.9789 24.3547 16.1718 24.6238L22.4992 33.3988C22.6487 33.6075 22.8457 33.7774 23.074 33.8947C23.3023 34.012 23.5552 34.0732 23.8119 34.0732C24.0685 34.0732 24.3215 34.012 24.5498 33.8947C24.7781 33.7774 24.9751 33.6075 25.1246 33.3988L35.8192 18.5707C36.0172 18.3016 35.8242 17.9258 35.4942 17.9258Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 3.25C13.4367 3.25 3.25 13.4367 3.25 26C3.25 38.5633 13.4367 48.75 26 48.75C38.5633 48.75 48.75 38.5633 48.75 26C48.75 13.4367 38.5633 3.25 26 3.25ZM26 44.8906C15.5695 44.8906 7.10938 36.4305 7.10938 26C7.10938 15.5695 15.5695 7.10938 26 7.10938C36.4305 7.10938 44.8906 15.5695 44.8906 26C44.8906 36.4305 36.4305 44.8906 26 44.8906Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.74987886e0fb7f98f81e7109b419c6d0.svg";
export { ForwardRef as ReactComponent };